import { HStack, IconButton, Page } from '@revolut-internal/ui-kit'
import { Link } from 'react-router-dom'

import { getRootRoute } from 'lib/router'
import { PermissionBoundary } from 'containers/PermissionBoundary'

import { MessageDebug } from './components/MessageDebug'
import { PromptProvider } from './providers/PromptProvider'

export const AiProcessDebug = () => (
  <Page>
    <Page.Main>
      <HStack space="s-16" height="100%">
        <Link to={getRootRoute()}>
          <IconButton mt="s-20" useIcon="BackButtonArrow" size={24} color="foreground">
            Back
          </IconButton>
        </Link>
        <PermissionBoundary permissions={['debug.process_actions.view']}>
          <PromptProvider>
            <MessageDebug />
          </PromptProvider>
        </PermissionBoundary>
      </HStack>
    </Page.Main>
  </Page>
)
